import * as React from 'react';

export type TSelectOptionValue = string | number;
export type TSelectValue = TSelectOptionValue | TSelectOptionValue[] | null | undefined;

export type TOptionChild = string | number | boolean;

export interface IOptionProps {
  value: TSelectOptionValue;
  children: TOptionChild | TOptionChild[];
}

export interface ISelectOption {
  value: TSelectOptionValue;
  label: string;
}

export type TSelectChild = React.ReactElement<IOptionProps>;

type TSelectPropsTemp = {
  tabIndex?: number;
  multiple?: boolean;
  disabled?: boolean;
  value?: TSelectValue;
  withoutArrow?: boolean;
} & {
  placeholder?: string;
  label?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // tslint:disable-next-line:no-any
  onChange?(e: React.ChangeEvent<HTMLSelectElement>, value: TSelectValue): any;
};

export interface ISelectCustom {
  invalid?: boolean;
  size?: EVisualSize;
}

export interface ISelectStyles {
  width?: string;
}

export interface ISelectProps extends TSelectPropsTemp {
  children: React.ReactNode;
  /**
   * Data метка для компонента(применяется в основном для автотестов)
   * */
  dataMark?: string;
  custom?: ISelectCustom;
  styles?: ISelectStyles;
  popupPostfix?: React.ReactNode;
  buttonAppearance?: TSelectButtonAppearance;
}

export enum EVisualSize {
  DESKTOP,
  MOBILE,
  ADAPTIVE,
}

export type TSelectButtonAppearance = 'default' | 'underlined';
